<h2 mat-dialog-title>Submit business information?</h2>
<mat-dialog-content>
  <p>
    You will not be able to edit this information after submitting. Make sure that all the information you've provided
    is accurate.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">Submit</button>
</mat-dialog-actions>
